module.exports = { //例子 this.$i18n.t('main.submit_audit')  {{$t('main.status_name')}}

    main: {
        'text1': 'プロフィールを見る',
        'text2': 'パスワードを変更する',
        'text3': '提出書類',
        'text4': 'ログアウト',
        'text5': 'ログアウト確認',
        'text6': 'ダッシュボードからログアウトいたしますが、よろしいでしょうか？',
        'text7': 'キャンセル',
        'text8': 'ログアウト',
        'text9': 'ありがとうございました！',
        'text10': 'プロフィールの作成サポートリクエストを承りました。リレーションシップ・マネージャーが3営業日以内にご連絡いたします。',
        'text11': 'わかりました',
        'text12': 'ダッシュボード',
        'text13': '取引',
        'text14': 'ブロックチェーン入金',
        'text15': 'ブロックチェーン出金',
        'text16': 'フィアット入金',
        'text17': 'フィアット出金',
        'text18': 'OTC',
        'text19': 'FX',
        'text20': 'KYC',
        'text21': 'コーポレート・ファイナンス',
        'text22': '会社情報',
        'text23': '取締役、監査、株主情報',
        'text24': '取引承認書',
        'text25': 'ブロックチェーン',
        'text26': 'フィアット',
        'text27': '商品',
        'text28': '準備中',
        'text29': 'もうすぐ発表予定です。しばらくしてからお越しください。',
        'text30': 'まだアカウントをお持ちでないですか？',
        'text31': 'アカウント登録',
        'text32': 'すぐにリセットリンクをメールでお送りします。',
        'text33': 'パスワードをお忘れですか？',
        'text34': 'ご確認済みの電子メールアドレスを入力してください。',
        'text35': 'メールアドレス',
        'text36': '送信',
        'text37': 'すでにアカウントをお持ちですか？',
        'text38': 'ログイン',
        'text39': 'メールアドレスを入力してください',
        'text40': 'USDT残高',
        'text41': 'USDC残高',
        'text42': 'USD残高',
        'text43': 'SGD残高',
        'text44': 'ETH残高',
        'text44_1': 'ETH',
        'text45': 'BTC残高',
        'text46': 'ようこそ！',
        'text47': 'ようこそ Finext Eastern銀行をご利用いただきありがとうございます。ダッシュボードにアクセスすることができます。私たちの銀行サービスの残りの部分を有効にするには、以下のリンクをクリックして、関連するドキュメントを提出してください。',
        'text48': 'リレーションシップマネージャーとの連携',
        'text49': '書類の提出についてサポートが必要な場合は、以下のボタンをクリックしてください',
        'text50': '自分で設定する',
        'text51': '書類提出',
        'text52': '必要な書類の一部または全部を持っているので、提出を進めたいです。(提出した書類は順次保存されますのでご注意ください）',
        'text53': '進む',
        'text54': '必要書類一覧',
        'text55': '会社設立証明書/ACRA',
        'text56': '全役員の身分証明書',
        'text57': '所有権/支配権構造',
        'text58': '全株主および支配人の身分証明書',
        'text58_y': '(身分証明書またはパスポート、公証人、会社秘書または公認会計士による正式な証明書（会員番号付き）。',
        'text59': '権限のある人物の身分証明書',
        'text60': '覚書と定款',
        'text61': '発行後3ヶ月以内の会社の住所証明書',
        'text61_y': '(提出日から3ヶ月以内に発行された公共料金の請求書または銀行取引明細書）',
        'text62': '関連するすべてのライセンス',
        'text63': '親会社の書類（該当する場合）',
        'text64': '表示件数を減らす',
        'text65': '後でにします',
        'text66': 'すべての項目をご記入の上、送信してください',
        'text67': '今すぐ送信する',
        'text68': '完了',
        'text69': '未入力',
        'text69_y': '会社申告書',
        'text70': 'このセクションでは、会社の取締役および株主の本人確認書類の提出が必要です',
        'text71': '編集',
        'text72': 'すべての項目が記されていることを確認してから送信してください。',
        'text73': '法人FI情報に不備があります',
        'text74': '会社情報に不備があります',
        'text75': '所有者/支配者/株主の情報に不備があります',
        'text76': '取引承認書情報に不備があります',
        'text77': '投稿を受け付けました',
        'text78': '提出ありがとうございました。お送りいただいた内容を確認し、折り返しご連絡いたします。',
        'text79': '保存済み',
        'text80': '今すぐKYCを送信しますか？',
        'text81': 'すべてのセクションが完了しました',
        'text82': '以下の欄がすべて記入されていることを確認してください。',
        'text83': '氏名',
        'text84': 'ID/パスポート番号',
        'text85': '役職名',
        'text86': '連絡先電話番号',
        'text87': 'ID/パスポート',
        'text87_y': '身分証明書（シンガポール人の場合）/パスポート（外国人の場合）の表と裏',
        'text88': 'ここにファイルをドラッグ＆ドロップしてください',
        'text89': 'ファイルを選択',
        'text90': '*最大10ファイルまで',
        'text91': 'メンバーの追加',
        'text92': '*最大3名まで',
        'text93': '宣言文',
        'text94': 'お客様は、BETH Corporationのサービスを利用する目的が合法的であること、当該資金がドミニカ国法またはその他の司法管轄権に基づくいかなる税犯罪の収益でないことを、以下の提出をもって確認します。',
        'text95': 'お客様は、BETHコーポレーションが発言及び提供した情報の正確性と完全性を信頼することを理解し、顧客はここに提供された情報及びデータが真実、完全かつ正確であることを証明し、変更があった場合には速やかにBETHコーポレーションに通知するものとします。',
        'text96': '取締役の確認書',
        'text97': '取締役名',
        'text98': '取締役の指名',
        'text99': '日付',
        'text100': 'このラベルの説明を表示する',
        'text101': 'dd/mm/yyyy',
        'text102': '取締役の署名',
        'text103': 'マウスまたはトラックパッドを使用して、ボックス内にサインしてください。',
        'text104': '保存',
        'text105': '署名',
        'text106': '最大3つまで追加可能',
        'text107': 'データを空にすることはできません',
        'text108': '保存に成功しました',
        'text109': '送信する前に署名してください',
        'text110': '入力内容が正しいことを確認してください。',
        'text111': 'FIタイプを選択してください。',
        'text112': 'はい',
        'text113': 'いいえ',
        'text114': 'BETH法人のAML/CFTに関する質問表',
        'text115': '署名された最新のAML/CFTポリシー',
        'text116': '最新の署名入り全社的リスク評価',
        'text117': '覚書と定款',
        'text118': '会社の定款(COI)。',
        'text118_y': '1. シンガポールで登録されている場合は、ACRA。',
        'text118_y2': '2. 2. 海外で登記されている場合は、提出から3ヶ月以内に真正性が証明された英訳版COIを提出してください。',
        'text119': '(シンガポールで登記されている場合） - 3ヶ月以内の日付または海外相当の英文のもの',
        'text120': '全役員の身分証明書',
        'text121': '(身分証明書またはパスポート、公証人、会社秘書、公認会計士による正式な証明書、会員番号付き）',
        'text122': 'すべての最終受益者の身分証明書',
        'text123': '親会社の書類（該当する場合）',
        'text124': '(公共料金の請求書、銀行取引明細書など）',
        'text125': '(シンガポールで登記されている場合) - 3ヶ月以内の日付または海外で同等の英文のもの',
        'text126': '取引目的',
        'text127': '(支払請求書等の書類）',
        'text128': '法人格をご確認の上、お進みください。',
        'text129': '重要：これまでにこのセクションでアップロードされた書類は保存されません。',
        'text130': '確認',
        'text131': '株主名',
        'text132': '出資比率',
        'text133': 'パスポート番号',
        'text134': '発行国',
        'text135': '選択してください。',
        'text136': '株主を追加する',
        'text137': '*最大5名まで',
        'text138': '主な役員・取締役情報',
        'text139': '役職名',
        'text140': '他の役員を追加する',
        'text141': '5人まで追加可能',
        'text142': '会社名',
        'text143': '登録住所',
        'text144': '国名',
        'text145': '郵送先住所',
        'text146': '電話番号',
        'text147': '会社ホームページ',
        'text148': '登録番号',
        'text149': '登録国',
        'text150': '登録日',
        'text151': '事業内容',
        'text152': '事業形態',
        'text153': '個人事業主',
        'text154': '有限責任事業組合',
        'text155': '有限責任会社',
        'text156': '株式会社',
        'text157': 'その他',
        'text158': '事業を行っている国',
        'text159': '従業員数',
        'text160': 'おおよその顧客数',
        'text161': '顧客の拠点がある上位5カ国',
        'text162': '年間売上高(米ドル)',
        'text163': '(書類の提出をお願いする場合があります）',
        'text164': '資金の出どころ',
        'text165': '取引頻度の高い通貨トップ3',
        'text166': '月間予想取引量',
        'text167': '<$10,000 USD',
        'text168': '10,000 - 100,000 USD',
        'text169': '10万ドル - 50万ドル',
        'text170': '50万ドル～100万ドル',
        'text171': '100万ドル～1,000万ドル',
        'text172': '>10,000,000ドル以上',
        'text173': '月間の想定取引頻度',
        'text174': 'アドホック・トランザクション要件',
        'text175': '10件未満',
        'text176': '10件以上20件未満',
        'text177': '20件以上',
        'text178': '稼働年数',
        'text179': 'お帰りなさい',
        'text180': '新しいアジア経済における銀行業務を、シンプル、迅速、かつ信頼性の高いものにします。',
        'text181': 'まだ口座をお持ちでない方はこちら',
        'text182': 'サインアップありがとうございます。お客様のアカウントは正常に作成されました。',
        'text183': 'パスワードは正常に更新されました。新しいパスワードでログインしてください。',
        'text184': 'ようこそ',
        'text185': '電子メール',
        'text186': 'パスワード',
        'text187': 'パスワードをお忘れの方',
        'text188': 'パスワードをリセットする',
        'text189': 'はい',
        'text190': 'キャプチャー',
        'text191': '電子メールアドレスは必須です',
        'text192': 'パスワードは空白にできません',
        'text193': '認証コードの入力が必要です',
        'text194': '認証コードが正しくありません',
        'text195': 'ログイン成功',
        'text196': 'アカウント作成',
        'text197': '電子メールの確認コードをメールで送信',
        'text198': 'OTPを要求する',
        'text199': '携帯電話番号',
        'text200': '国番号',
        'text201': 'パスワードの確認',
        'text202': 'CIコード（オプション）',
        'text203': '氏名を入力してください',
        'text204': 'メールアドレスを入力してください',
        'text205': 'メール認証コードを記入してください',
        'text206': '電話番号をご記入ください',
        'text207': 'パスワードを入力してください',
        'text208': '確認パスワードを入力してください',
        'text209': '2つのパスワードが一致しませんので、再度入力してください。',
        'text210': '登録成功',
        'text211': 'パスワードの再設定',
        'text212': '新しいパスワードを入力してください',
        'text213': '新しいパスワード',
        'text214': '新しいパスワードの確認',
        'text215': '変更に成功しました',
        'text216': 'ダッシュボードにアクセスするために必要な書類を提出してください。',
        'text217': '会社概要証明書(SSM/SSL)',
        'text218': '株主名',
        'text219': '身分証明書/パスポート',
        'text220': '氏名',
        'text221': '株主を3名まで追加',
        'text222': '名前を記入してください',
        'text223': '会社概要のアップロードが必要です',
        'text224': '株主の情報を追加する必要があります',
        'text225': 'アップロードに成功しました',
        'text226': 'パスワードはいつでも更新可能です。',
        'text227': 'プロフィールを完成させると、すべての機能を利用できるようになります。',
        'text228': '審査後、こちらからご連絡いたします。',
        'text229': 'レビュー保留中',
        'text230': '投稿に失敗しました。近日中にご連絡いたします。',
        'text231': '失敗',
        'text232': '今すぐ完了',
        'text233': 'KYCのやり方がわからない？リレーションシップマネージャーがお手伝いします。',
        'text234': 'プロファイルの編集',
        'text235': '*ファイルサイズは5MBまで',
        'text236': '更新',
        'text237': '現在のパスワード',
        'text238': '新しいパスワードを入力してください。',
        'text239': 'ファイルサイズは5Mを超えることはできません',
        'text240': 'ファイルの種類が違う',
        'text241': '会社概要',
        'text242': '-日付を選択してください-',
        'text243': 'ダウンロードはこちら',
        'text244': '上記のメールにOTPが送信されましたので、コードを入力してください。',
        'text245': 'パスワードは8文字以上で、大文字、小文字、数字1つ以上を含む必要があります。',
        'text246': 'パスワードは8文字から12文字の組み合わせであることができます',
        'text247': '親会社の書類（該当する場合）',
        'text248': 'あなたは15分以上のために非アクティブになっている',
        'text249': 'すべて表示',
        'text250': '電子メール',
        'text251': '口座概要',
        'text252': '口座名',
        'text253': '口座番号',
        'text254': '参照番号',
        'text255': '残高',
        'text256': 'このセクションでは、役員や株主の身分証明書など、会社のサポート文書のアップロードが必要です',
        'text257': 'セッションがまもなく終了します',
        'text258': 'セッションを継続しますか？',
        'text259': '今すぐログアウトする',
        'text260': 'ログインを継続する',
        'text261': '*上限10ファイル jpeg pdf png、最大サイズ10MB',
        'text262': 'このページから離れようとしています。アップロードされたすべてのドキュメントは保存されません',
        'text263': '保存して進む',
        'text264': 'アクセスが拒否されました',
        'text265': '申し訳ありませんが、あなたのKYCが承認されるまで、この機能にアクセスすることはできません。プロフィールページでKYCのステータスを確認することができます',
        'text266': 'わかりました',
        'text267': 'プライベートバンキング商品',
        'text268': 'ストラクチャード商品',
        'text269': '投資銀行業務',
        'text270': '取引履歴',
        'text271': '新規フィアット預金',
        'text272': '「私の銀行の詳細」ボタンをクリックすると、銀行の詳細が表示されます。最低入金額1,000米ドルまたはその相当額が必要となりますのでご注意ください。',
        'text273': '当社の銀行詳細',
        'text274': '必ず参照番号を入れてください',
        // 'text275': "BETHの口座に振り込む際、お客様のお名前またはイニシャルを銀行に提供に、必ず参照番号'を付けてください。参照番号は、お客様のBETH口座への送金を識別するための識別子です。",
        'text276': '受益者銀行',
        'text277': '銀行住所',
        'text278': '銀行所在国',
        'text279': 'SWIFTコード',
        'text280': '銀行口座番号です',
        'text281': 'コルレス銀行の国際コード',
        'text282': '口座番号（USD）',
        'text283': '通貨',
        'text284': '会社住所',
        'text285': '銀行の詳細情報をコピーする',
        'text286': '新しいデジタル資産の入金',
        'text287': '次の QR コードをコピーまたはスキャンして、デジタル アセット ウォレットの入金アドレスを選択します。',
        'text288': 'USDT残高 (ERC20 & BEP20)',
        'text288_1': 'USDT残高',
        'text288_3': 'USDT',
        'text288_2': '(ERC20 BEP20)',
        'text289': 'USD概算',
        'text290': '住所',
        'text291': 'コピー',
        'text292': 'USDC残高(ERC20 & BEP20)',
        'text292_1': 'USDC残高',
        'text292_3': 'USDC',
        'text292_2': '(ERC20 & BEP20)',
        'text293': 'BTC残高',
        'text293_1': 'BTC',
        'text294': 'ETH残高',
        'text295': 'USDT (TRC20) 残高',
        'text296': 'USDC (TRC20) 残高',
        'text297': 'コピー成功',
        'text298': '銀行名 : ',
        'text299': '銀行住所：',
        'text300': '銀行コード : ',
        'text301': '支店名：',
        'text302': '銀行口座番号：',
        'text303': '銀行口座名：',
        'text304': '国名:',
        'text305': '通貨:',
        'text306': 'SWIFTアドレス/コード：',
        'text307': '会社住所：',
        'text308': '参照番号：',
        'text309': '取引の詳細',
        'text310': '取引日',
        'text311': 'TxID',
        'text312': '取引ID',
        'text313': '詳細',
        'text314': '金額',
        'text315': '送金元アドレス',
        'text316': '管理者レビュー',
        'text317': '成功',
        'text318': '承認待ち',
        'text319': '拒否されました',
        'text320': 'トランザクションの処理中',
        'text321': 'トランザクション失敗',
        'text322': 'フィルター',
        'text323': '日付範囲',
        'text324': '開始日',
        'text325': '終了日',
        'text326': 'TXID',
        'text327': 'トランザクションの種類',
        'text328': 'すべて',
        'text329': 'リセット',
        'text330': '検索けんさく',
        'text331': '',
        'text332': '白 - デジタルアセット取引',
        'text333': 'エクスポート',
        'text334': '通貨タイプ',
        'text335': '現在ダウンロードするデータはありません',
        'text336': 'フィアット取引履歴',
        'text337': 'デジタルアセット取引履歴',
        'text338': '送金・支払明細',
        'text339': '出金額',
        'text340': '受取人の詳細',
        'text341': '氏名',
        'text342': 'ウォレットアドレス',
        'text343': 'ネットワークタイプ',
        'text344': 'すべて',
        'text346': '取引履歴',
        'text347': '送金額',
        'text348': '受取人名',
        'text349': '送金・支払明細',
        'text350': '受取人の受取額',
        'text351': '銀行詳細',
        'text352': '受取人の銀行名',
        'text353': '受取銀行のSWIFTコード',
        'text354': '仲介銀行の詳細（オプション）',
        'text355': '仲介銀行名',
        'text356': '仲介銀行の国',
        'text357': '仲介銀行スウィフトコード',
        'text358': '仲介銀行の住所',
        'text359': 'その他の詳細',
        'text360': '取引目的',
        'text361': '新しいアドレスの追加',
        'text362': '私のアドレス',
        'text363': '消去',
        'text364': 'データなし',
        'text365': '受取人の詳細',
        'text366': 'ウォレットアドレス',
        'text367': '削除確認',
        'text368': '本当にこのアドレスをリストから削除しますか？',
        'text369': '削除する',
        'text370': 'マイアドレスの管理',
        'text371': '名前を記入してください',
        'text372': 'アドレスを記入してください',
        'text373': '種類を選択してください',
        'text374': '追加に成功',
        'text375': '編集に成功',
        'text376': '削除に成功',
        'text377': '新規受取人の追加',
        'text378': '私の受取人',
        'text379': 'この受取人をリストから消去しますか？',
        'text380': '受取人',
        'text381': '銀行口座番号を入力してください',
        'text382': '受取人の名前を記入してください',
        'text383': '銀行コードを入力してください',
        'text384': '銀行の住所を記入してください',
        'text385': '仲介銀行名を記入してください',
        'text386': '仲介銀行の国を選択してください',
        'text387': '仲介銀行のコードを記入してください',
        'text388': '仲介銀行の住所を記入してください',
        'text389': '金額を入力してください',
        'text390': '詳細を確認する',
        'text391': '受取人を選択',
        'text392': '新しいウォレットアドレスを追加する',
        'text393': 'お気に入りの受取人として保存する',
        'text394': '続ける',
        'text395': '保存',
        'text396': '新規送金・支払い（デジタルアセット）',
        'text397': '送信前に以下の詳細がすべて正しいことを確認してください',
        'text398': '送金・支払いの詳細',
        'text399': 'OTPを入力する',
        'text400': '確認と続行',
        'text401': 'ご指示を受けました。',
        'text402': '出金依頼は3営業日以内に処理されます',
        'text403': '認証コードを入力してください',
        'text404': 'よく使う受取人',
        'text405': 'その他の詳細',
        'text406': '電子メール（オプション）',
        'text407': '事業費',
        'text408': '集金支払い',
        'text409': '現金払い',
        'text410': '商品の購入販売',
        'text411': '分割払契約',
        'text412': '会社内取引',
        'text413': '請求書支払い',
        'text414': '仕入先支払い',
        'text415': '貿易サービス',
        'text416': '国庫支出',
        'text417': 'チャリティー支払い',
        'text418': '教育',
        'text419': '勉学',
        'text420': '外国人労働者賦課金',
        'text421': '政府保険',
        'text422': '保険料',
        'text423': '投資・証券',
        'text424': 'ローン',
        'text425': '配当金',
        'text426': '利息',
        'text427': 'その他',
        'text428': 'リベート',
        'text429': '払戻し',
        'text430': '留保',
        'text431': 'ケーブルテレビ支払い',
        'text432': 'クレジットカード払い',
        'text433': '駐車場料金',
        'text434': 'デビットカード決済',
        'text435': 'デンタルサービス',
        'text436': '料金＆チャージの支払い',
        'text437': '病院での治療',
        'text438': '医療サービス',
        'text439': '電話代',
        'text440': '家賃',
        'text441': '町内会サービス料',
        'text442': '道路課金',
        'text443': '公共事業',
        'text444': 'ボーナス払い',
        'text445': 'コミッション',
        'text446': '給与支払い',
        'text447': 'GST（消費税）',
        'text448': '純所得税',
        'text449': '固定資産税',
        'text450': '道路税',
        'text451': '税金の支払い',
        'text452': '新規送金＆支払い（フィアット）',
        'text453': '正しいEメールを記入してください',
        'text454': '取引目的を選択してください',
        'text455': '他の口座への振込・支払',
        'text456': '受取人にお金が届くまで、最大3営業日かかる場合があります',
        'text457': '他の通貨への送金',
        'text458': 'あなたが送る',
        'text459': '利用可能残高',
        'text460': '受取人の受取額',
        'text461': 'レートは5分ごとに更新され、金額も更新されます',
        'text462': '他のアドレスへの転送/支払い',
        'text463': '送信前に正しい情報を入力したことを確認してください',
        'text464': '送金/支払額',
        'text465': 'ページをリフレッシュ',
        'text466': '5分ごとに料金が更新され、金額も更新されます。お取引を継続される場合は「OK」をクリックしてください。',
        'text467': 'リフレッシュ',
        'text468': '出金額が0のため、出金できません',
        'text469': '出金額を入力してください',
        'text470': 'お引き出しされるコインの量が、お引き出し可能な最低金額に達していません。お引き出し可能なコインの最低額は',
        'text471': '出金額が上限額を超えています',
        // 'text472': '入金参照番号は、お客様のBETH口座への着金送金を識別するための一意の識別子です。お客様のお名前またはイニシャルを記入する際には、必ずこのリファレンスを',
        // 'text473': "BETH口座への送金のために銀行にお名前またはイニシャルを提供する際に、''リファレンス''を含めるようにしてください。",
        'text474': '預金参照番号',
        'text475': '中国元残高',
        'text476': 'ポンド残高',
        'text477': 'AUD残高',
        'text478': '香港ドル残高',
        'text479': '取引タイプ',
        'text480': 'デポジット',
        'text481': '送金と支払い',
        'text482': 'フィアットへの送金',
        'text483': '通貨を選択してください',
        'text484': '(TRC20)',
        'text485': '申し訳ございませんが、まだこの機能にアクセスできません',
        'text486': 'あなたのプロフィールが承認されると、この機能にアクセスできるようになります',
        'text487': 'プロフィールページでプロフィールステータスを確認することができます',
        'text488': 'ネットワークの種類に合った正しいウォレットアドレスが以下に入力されていることを確認してください。他のネットワークのウォレットアドレスを入力すると、資金を失うことになります。',
        'text489': '拒否理由',
        'text490': '*最大1ファイルまで',
        'text491': 'デビットカード',
        'text492': '役員・社員が利用できるカードです。',
        'text493': '今すぐ申し込む',
        'text494': 'デビットカード',
        'text495': '近日公開',
        'text496': '近日中に、何かエキサイティングなことが起こるかもしれません。どうぞご期待ください。',
        'text497': '応募対象者',
        'text498': 'ディレクター',
        'text499': 'アソシエイト',
        'text500': '株主を選択してください。',
        'text501': 'カード費用',
        'text502': 'セキュアードVISA (米ドル)',
        'text503': '年会費',
        'text504': 'カード費用',
        'text505': '休眠口座の手数料',
        'text506': 'カード有効化',
        'text507': 'POS/オンライン購入',
        'text508': 'ATMでの出金',
        'text509': 'ATM残高照会',
        'text510': 'ロードフィー(カードに直接入金)',
        'text511': 'カードの申し込み',
        'text512': 'カード',
        'text513': '以下の内容をご確認の上、お申し込みください。',
        'text514': 'カード情報',
        'text515': 'カードの種類',
        'text516': 'VISAデビットカード',
        'text517': 'お申し込み内容',
        'text518': '敬称',
        'text519': '名',
        'text520': '姓',
        'text521': 'ユーザー名 (インターネットバンキングへのログイン用)',
        'text522': '生年月日',
        'text523': 'カードに記載されるお名前',
        'text524': '现居的国家',
        'text525': '都道府県名',
        'text526': '市町村',
        'text527': '郵便番号',
        'text528': 'KYCの詳細',
        'text529': '身分証明書/パスポート番号',
        'text530': '発行日',
        'text531': '有効期限',
        'text532': '身分証明書またはパスポートの表面',
        'text533': '身分証明書またはパスポートの裏面',
        'text534': '住所を証明するもの',
        'text535': '住所証明発行者',
        'text536': '住所証明発行日',
        'text537': 'ご提出ありがとうございました。',
        'text538': '応募内容を確認し、メールにてご連絡いたします。',
        'text539': '以下の項目を入力してください。',
        'text540': '氏 (Mr)',
        'text541': '夫人 (Mrs)',
        'text542': 'Ms (Ms)',
        'text543': '(公共料金請求書、銀行取引明細書、バンクレター、クレジットカード明細書のいずれか、申込日から3ヶ月以内のものをご提出ください)',
        'text544': '(公共料金や銀行名などの発行元名)',
        'text545': '(発行された日付のスタンプが押された書類。90日以上前のものは不可)',
        'text546': '敬称を選択してください。',
        'text547': '名を記入してください。',
        'text548': '姓を入力してください。',
        'text549': 'ユーザーネームを入力してください。',
        'text550': '電子メールを入力してください。',
        'text551': '携帯電話番号を入力してください。',
        'text552': '生年月日を選択してください。',
        'text553': 'カードに記載されるお名前をご記入ください。',
        'text554': '住所を入力してください。',
        'text555': 'お住まいの国を選択してください。',
        'text556': '都道府県を入力してください。',
        'text557': '市町村をご記入ください',
        'text558': '郵便番号を入力してください。',
        'text559': '国民ID/パスポート番号をご記入ください。',
        'text560': '発行日を選択してください。',
        'text561': '有効期限を選択してください。',
        'text562': '身分証明書またはパスポートの表をアップロードしてください。',
        'text563': '身分証明書またはパスポートの裏面をアップロードしてください。',
        'text564': '住所証明のアップロード',
        'text565': '住所証明の発行元を記入してください。',
        'text566': '住所証明の発行日を選択してください。',
        'text567': 'カード名義人名',
        'text568': 'カード残高',
        'text569': '銀聯デビットカード',
        'text570': '確認中',
        'text571': '認証完了',
        'text572': '認証に失敗しました',
        'text573': 'KYC発行国',
        'text574': '国番号を選択してください',
        'text575': 'KYC発行国を選択してください。',
        'text576': '住所証明の種類',
        'text577': '提出書類の言語',
        'text578': 'ID/Passportの言語を選択してください',
        'text579': '会社名',
        'text580': 'トップアップ履歴',
        'text581': '申込状況',
        'text582': 'カード番号',
        'text583': '承認',
        'text584': '不承認',
        'text585': '承認済み',
        'text586': '保留',
        'text587': '処理中',
        'text588': '有効',
        'text589': 'ブロックされました',
        'text590': 'カード申し込みが承認されました。',
        'text591': 'カードの承認をありがとうございます。3営業日以内に審査を行います。',
        'text592': '会社申し込み状況',
        'text593': 'カード残高',
        'text594': 'カードを拒否する',
        'text595': 'このカード申込を却下してもよろしいですか？',
        'text596': '理由をお聞かせください。',
        'text597': '却下を確認する',
        'text598': '理由をお書きください。',
        'text599': 'KYCが承認されていることを確認してください。',
        'text600': 'リンクをコピー',
        'text601': 'クレジットカード明細書',
        'text602': '公共料金の請求書',
        'text603': '銀行口座明細書',
        'text604': '銀行レター',
        'text605': '英語',
        'text606': 'スペイン語',
        'text607': 'フランス語',
        'text608': 'アラビア語',
        'text609': '中国語',
        'text610': '日本語',
        'text611': 'ロシア語',
        'text612': 'ポルトガル語',
        'text613': 'ドイツ語',
        'text614': 'イタリア語',
        'text615': 'ヒンディー語',
        'text616': 'その他',
        'text617': '発行国',
        'text618': '住所証明（表面）',
        'text619': '住所証明（裏面、任意）',
        'text620': '備考（任意）',
        'text621': '住所証明の言語を選択してください。',
        'text622': '検索',
        'text623': '例：カード名義人、カード番号下4桁など',
        'text624': 'すべてのステータス',
        'text625': '有効化',
        'text626': 'トップアップ',
        'text627': 'カードの有効化',
        'text628': 'カードをアクティブ化するには、KITコードを入力してください。',
        'text629': 'カードの16桁の数字',
        'text630': 'KITコード',
        'text631': 'アクティベート成功!',
        'text632': 'カードのアクティベーションが完了しました。',
        'text633': '年会費とトップアップチャージ',
        'text634': '年会費',
        'text635': '最低チャージ金額',
        'text636': 'トップアップの上限額',
        'text637': 'カードのトップアップ',
        'text638': 'アカウントウォレットに十分な残高があることを確認してください。',
        'text639': 'トップアップに成功しました。',
        'text640': '米ドルのトップアップに成功しました。',
        'text640_r': ' をカードにチャージしました。',
        'text641': 'トップアップに失敗しました',
        'text642': '何か問題が発生しました。後でもう一度お試しください。',
        'text643': '再試行',
        'text644': 'カード有効化手数料',
        'text645': '手数料',
        'text646': '日付と時間',
        'text647': 'から',
        'text648': 'トップアップ金額(USD)',
        'text649': '失敗',
        'text650': '最小値',
        'text651': ' 最大値',
        'text652': '利用可能残高',
        'text653': 'トップアップの金額が、1日のトップアップ限度額を超えました。',
        'text654': 'トップアップを続けるには、トップアップ量を減らしてください。',
        'text655': 'あなたの銀行口座に十分な',
        'text655_2': ' 残高がありません。銀行口座にトップアップするか、他の通貨を選択してください。',
        'text656': '今すぐマイアカウントにトップアップする',
        'text657': '取得するもの',
        'text658': 'カード番号',
        'text659': 'カード限度額',
        'text660': '16桁のカード番号を入力してください。',
        'text661': '身分証明書番号を入力してください。',
        'text662': '金額が少なすぎます',
        'text663': '最低額より少ない額になっています',
        'text664': '上限を超えた金額 です',
        'text665': '種類 ',
        'text666': 'チャージ',
        'text667': 'カード費用',
        'text668': 'カード有効化手数料 ',
        'text669': '手数料 ',
        'text670': 'カード交換 ',
        'text671': '上記料金は全てUSドルです。',
        'text672': 'ユーザー名の形式は英字（大文字、小文字）、数字、アンダースコアです。',

        // BETH
        'text673_ok': '更新する ',
        'text673': 'あなたのアカウントに認証アプリをペアリングしてください。',
        'text674': 'QRコードをスキャンしてください',
        'text675': 'Authenticatorアプリでスキャンするか、上記の設定キーを入力し、生成された6桁のコードを入力して続行してください。',
        'text676': '認証アプリからの6桁コードを入力してログインしてください。（登録済みの認証アプリ用）',
        'text677': '6桁のコード',
        'text678': 'ご確認済みのメールアドレスを入力してください。指示がメールでお送りされます。',
        'text679': '（少なくとも大文字1文字、小文字1文字、数字1文字、特殊文字1文字を含む、最低8文字のパスワードを設定してください）',
        'text680': 'パスワードが更新されました',
        'text681': '新しいパスワードを正常に更新しました。最新のパスワードを使用してログインしてください。',
        'text682': 'ログイン',
        'text683': '性別',
        'text684': '認証アプリからの6桁のコードを入力してください。',
        'text685': 'カードの成功した有効化"',
        'text686': '末尾',
        'text686_r': 'のデビットカードが正常に有効化されました。',
        'text687': 'カードの管理',
        'text688': '私のカード',
        'text689': 'プロフィール',
        'text690': 'ご利用の期限',
        'text691': 'CVV',
        'text692': 'カードを有効化する',
        'text693': '二段階認証を設定',
        'text694': '基本情報',
        'text695': '変更住所',
        'text696': '新しい住所',
        'text697': '3 営業日以内に書類を確認させていただきます。 プロフィールをチェックしてアップデートをご確認ください。',
        // 'bt1': 'Finextイースタン銀行が提供',
        'bt2': '新しいカードを申し込む',
        'bt3': '*あなたのデジタルウォレットには指定されたトークンのみが受け付けられます。もし誤って他のトークンを入金した場合は、すぐに弊社カスタマーサポートにご連絡ください。',
        'bt4': '',
        'bt5': '',
        'bt6': '',
        'bt7': '',
        'bt8': '',
        'bt9': '',
        'bt10': '',

        'btext674': 'さまざまな法定通貨から入金できます。',
        'btext675': '法定通貨から入金',
        'btext676': '入金の詳細 ',
        'btext677': 'ご指示を受けました。',
        'btext678': '担当のリレーションシップ・マネージャーまたはアカウント・マネージャーに通知致しましたので、まもなくご連絡いたします。',
        'btext679': 'その他の通貨 ',
        'btext680': '銀行から ',
        'btext681': 'どの国から入金されていますか？',
        'btext682': '通貨 ',
        'btext683': '通貨を選択してください',
        'btext684': '金額を入力してください。',
        'btext685': '銀行名からお選びください ',
        'btext686': '送金元の国を選択してください',
        'btext687': '新規のフィアット入金先  ',
        'btext688': '送金と支払い',
        'btext689': 'チャージ',
        'btext690': 'カード年会費 ',
        'btext691': 'カード費用',
        'btext692': 'カード有効化手数料 ',
        'btext693': '年会費の払い戻し ',
        'btext694': '払い戻し手数料 ',
        'btext695': '為替手数料',
        'btext696': '為替手数料',

        'text698': 'パスポート(Passport)',
        'text699': '国民ID (National ID)',
        'text700': 'IDの種類を選択してください。',
        'text701': '入金タイプ',
        'text702': '受け取る',
        'text703': 'すべての法定通貨預金は USDC に変換され、USDC ウォレットに反映されることに注意してください。 外国為替レートと法定通貨から USDC への換算手数料が適用されます。',
        'text704': '最低1,000 USD/USDT/USDCまたは同等のデポジットが必要です。',
        'text705': 'PINコードをリセット',
        'text706': '新しいPINコードを入力',
        'text707': 'ご利用のカードのPINコードを変更します。覚えやすい4桁の数字を設定し、絶対に他の人に教えないでください。',
        'text708': '新PIN確認',
        'text709': '',
        'text710': 'カテゴリ',
        'text711': '取引合計',
        'text712': 'トランザクションID',
        'text713': '本人声明，本次交易の資金の出所：',
        'text714': '資産の売却',
        'text715': 'ビジネスの利益',
        'text716': '経営利益',
        'text717': 'トレード',
        'text718': 'その他',
        'text719': 'サービス料金',
        'text720': 'KYC審査合格',
        'text721': 'お客様各位、',
        'text722': '入金にご興味をお持ちいただきありがとうございます',
        'text723': 'ビジョンライフへ。',
        'text724': 'BETH では現在、USD、CNY、GBP、AUD、SGD、HKD での入金を受け付けており、USDT と USDC で変換および保持されます。',
        'text725': 'したがって、BETH の顧客の利便性を高めるために、当社は PayBridge と提携して、シームレスな変換プロセスを提供します。',
        'text726': 'USDT（TRC20）まで。 PayBridge では、KYC が承認された後、いくつかの簡単な手順で 47 を超える異なる法定通貨から USDT (TRC20) に変換できます。',
        'text727': '変換が成功すると、',
        'text728': 'Paybridge の USDT に送信すると、USDT は 1 時間以内に BETH USDT ウォレットに自動的に入金されます。 預金残高を確認するには、BETH ダッシュボードにアクセスしてください。',
        'text729': 'プロセスの概要は次のとおりです',
        'text730': 'BETH --> Paybridge --> シンプルな PayBridge KYC を完了 --> 法定通貨を USDT (TRC20) に変換 --> USDT が BETH USDT ウォレットに自動的に入金されます',
        'text731': 'PayBridge にリダイレクトされます。',
        'text732': '* すべてのデジタル資産の譲渡には次の条件が適用されることに注意してください。',
        'text733': '管理費とガソリン代の金額',
        'text734': ' ',
        'text735': '述べる',
        'text736': '※ウォレットには当社指定のトークンのみを受け取ることができます。 誤って間違ったトークンをクレジットしてしまった場合は、support@finexteasternbank.com までご連絡ください。',
        'text737':  '振替固定料金',
        'text738':  '振替',
        'text738_2':'手数料',
        'text739':  '振替手数料',
        'text740':  '振替 固定料金',
        'text741': '差し引く',
        'text742': 'チャージ金額',
        'text743': 'USDTでのトップアップ金額',
        'text744': '差し引かれる合計金額',
        'text745': 'USDTでの合計控除額',
        'text746': '差引後の残高',
        'text747': '口座概要',
        'text748': 'フィアット入金',
        'text749': '数字資産の入金',
        'text750': 'フィアット送金と支払い',
        'text751': '数字資産の送金と支払い',
        'text767': '取引詳細',
        'text768': 'カードの末尾4桁',
        'text769': '出金',
        'text770': '預入れ',
        'text771': '残高 (オーバードラフト)',
        'text772': '送金/支払い（受取人へ）',
        'text773': '送金者の口座名',
        'text774': '送金者の口座名を入力してください',
        'text775': '緑 - 法定通貨取引',
        'text776': '白 - デジタルアセット取引',
        'text777': '通信',
        'text778': '参照する',
        'text779': '銀行取引明細書',
        'text780': '銀行の流れ（ 6ヶ月近く ）',
        'text781': '銀行取引明細書',
        'text782': '提出されるすべての書類は、英語で記載されているか、またはその公認翻訳文が添付されていなければなりません。',
        'text783': '取引に関するアドバイス',
        'text784': '受信転送',
        'text785': 'カードの種類',
        'text786': '手数料を直接チャージ',
        'text787': '',
        'text788': '',
        'text789': '',
        'text790': '',
        'text791': 'その他',
        'text792': 'アカウントを有効にするには、最低初回入金額は1,000米ドルまたは同等額が必要です。',
        'text793': '着金額',

    },

    // 银行卡预约
    bank_card:{
        card_reservation        :"事前注文モジュール",
        contract_management     :"契約管理",
        Card_management         :"カード管理",
        KYC_info                :"KYCの詳細",
        Personal_Details        :"個人情報",
        Mobile_Phone            :"携帯電話",
        Gender                  :"性别",
        Male                    :"男性 (Male)",
        Female                  :"女性 (Female)",
        Username_Beth           :"ユーザー名",
        Name_appear             :"カードに記載されるお名前",
        Proof_Identity          :"身分証明書",
        Passport_National       :"パスポート/国民ID番号",
        Select_language         :"文書の言語を選択する",
        Address_Proof           :"住所証明書をアップロードする（表面）",
        Address_Proof_Back      :"住所証明書のアップロード（裏面、オプション）",
        Address_Type            :"住所証明の種類",
        Address_Language        :"文書の言語を選択する",
        Address_Issued_By       :"アドレスの発行者",
        Address_Issued_Date     :"アドレス発行日",
        reservation_management  :"予約注文 - カード管理",
        Please_enter_name       :"カードに名前を記入",
        Please_enter_email      :"メールアドレスを入力して",
        state                   :"状態",
        uncommitted             :"未処理",
        approved                :"承認済み",
        rejected                :"拒否",
        active                  :"アクティブ化された",
        blocked                 :"一時凍結",
        kyc_approved            :"KYC審査合格",
        card_level              :"カードのランク",
        Premier                 :"プレミア",
        Prestige                :"プレステージ",
        Card_class              :"カードの種類",
        VISA                    :"ビザ",
        Mastercard              :"マスターカード",
        UnionPay                :"銀聯",
        card_number             :"カード番号",
        There                   :"合計",
        are_records             :"レコード数",
        application_date        :"リクエスト日",
        Card_name               :"カードに記載されている名前",
        email                   :"電子メール",
        Corporate_Clent         :"法人顧客",
        Card_Fee                :"カード費用",
        unpaid                  :"未払い",
        paid                    :"支払済み",
        Annual_Membership       :"年間会員",
        branded_card_level      :"カード層",
        branded_card_category   :"カードの種類",
        Date_lssuse             :"発行日",
        Date_Expiry             :"有効期限",
        Corporate_Client_Action :"法人顧客の操作",
        Bind                    :"練る",
        unbind                  :"解放する",
        binding_card            :"バインドカード",
        create_time             :"注文日",
        order_id                :"注文ID",
        amount_num              :"注文金額",
        status_1                :"保留中",
        status_2                :"承認する",
        status_3                :"拒否されました",
        status_4                :"部分的に割り当てられています",
        status_5                :"割り当て済み",
        status_remark           :"ステータスの備考",
        operate                 :"アクション",
        select                  :"選ぶ",
        allocated_cards         :"割り当てられたカード",
        kit_number              :"KITコード",
        is_unbind               :"カードのバインドを解除してよろしいですか?",
        confirm                 :"確認する",
        bind_success            :"バインド成功",
        unbind_success          :"キャンセルが成功しました",
        card_issuing_record     :"カード事前注文 - 契約管理 - 契約詳細の表示 - カード割り当て記録の表示",
        Date_issue              :"発行日",
        check_order             :"事前注文モジュール - 契約管理 - 注文の表示",
        con_management          :"事前注文モジュール - 契約管理",
        Start_date              :"開始日/終了日",
        Contract_ID             :"契約ID",
        total_amount            :"契約数量",
        payment_amount          :"支払った数量",
        left_amount             :"注文可能数量",
        order_amount            :"注文数量",
        place_order             :"注文",
        View_the_contract       :"契約書を見る",
        check_an_order          :"注文の詳細を表示する",
        order_num               :"注文数量",
        Minimum_quantity        :"バッチごとの最低注文数量",
        Contract_term_month     :"契約期間",
        contract_quantity       :"契約数量",
        Number_reservation      :"予約注文金額",
        zhang                   :"张",
        date_of_payment         :"支払い日付",
        di                      :"番号",
        Period_quantity         :"入金時の数量",
        Minimum_order_quantity  :"バッチごとの最低注文数量",
        available_quantity      :"発行可能数量",
        Current_number_audited  :"現在保留中のKYC",
        Current_number_issued   :"現在発行保留中",
        Order_success           :"注文が成功しました",
        Allocated_quantity      :"割り当て数量",
        unallocated_quantity    :"未割り当て数量",
        Ass_management          :"ユーザーアクセス管理",
        KYC_Processing          :"KYC処理",
        Printing                :"印刷",
        Card_Binded             :"使用カード",
        Activated               :"既に有効化済み",
        freeze                  :"ブロック",
        Whether_freeze_account  :"カードをブロックしますか？",
        Freezing_success        :"カードのブロックが成功しました",
        Total_Order             :"合計注文数量",
        Card_Unbind             :"利用可能なカード",
        KYC_Pending             :"KYC保留中のユーザー",
        KYC_Approved_binded     :"ユーザー保留中のカード",
        username_email          :"ユーザーアクセスのユーザー名/メールアドレスを入力してください",
        Subaccount_status       :"アカウントのステータス",
        start                   :"有効",
        forbidden               :"無効化されました",
        in_all                  :"合計",
        Bar_data                :"レコードの数",
        User_name_subaccount    :"セカンダリアカウントのユーザー名",
        Subaccount_mailbox      :"セカンダリアカウントのメールアドレス",
        operation               :"選択肢",
        permission_view         :"アクセス権の表示",
        Ass_Acc_View            :"ユーザー アクセス モジュール - アクセス権の表示",
        Remarks                 :"備考",
        group_name              :"ユーザーアクセスグループ",
        describe                :"説明",
        thaw                    :"制限解除",
        Operation_Status        :"運用状況",
        Successful_thawing      :"制限解除が成功しました",
        Card_Binded2            :"紐づけられたカード",
        FEB_Debit_Cards         :"デビットカード",
        FEB_VISA_Premier        :"VISAプレミア",
        FEB_VISA_Premier_m      :"",
        View_Plan               :"プランを見る",
        Directors_Staffs        :"取締役、スタッフ、および従業員は、このカードを申請する資格があります。",
        Client_Block            :"クライアントブロック",
        Admin_Block             :"管理者ブロック",
        User_Block              :"ユーザーブロック",
        Enter_Code              :"入力コード",
        Please_enter_OTP        :"OTP認証コードを入力し、「認証」をクリックして認証を完了してください",
        Verify                  :"検証",
        Create_Password         :"パスワードの作成",
        enter_Password          :"パスワードを再入力",
        My_mailing_address      :"私の郵送先住所は、上記で入力された居住地と同じです。",
        Please_provide          :"カードを安全にお届けするための郵送先のご住所をご記入ください。",
        For_ID_Card             :"発行日のない身分証明書の場合は、18歳からの日付を挿入してください。",
        ID_Card_without         :"有効期限が切れていない身分証明書には、生まれた日から少なくとも55年加算されます。",
        Important_Please        :"重要：身分を証明する書類の英訳をアップロードしてください。",
        If_you_are              :"英語以外の書類を提出する場合は、英訳を添付してください。原本には必要事項を明記し、翻訳したものをアップロードしてください。必要であれば、信頼できる翻訳サービスを利用してください。",
        Image_File_Type         :"*画像ファイルの種類：jpeg、png、pdfの拡張子。",
        Image_Size_Limit        :"*画像サイズ制限：1文書につき5MBまで。",
        Allow_up_to             :"*最大1ファイルまでアップロード可能です。",
        Please_upload_English   :"重要：住所証明の英訳をアップロードしてください。",
        label_in_English        :"（ラベルは英語）",
        Please_ensure_that      :"上記がWEB明細書の場合は名前/日付/住所の記載されている画像(複数枚可)",
        Issuing_authority       :"電力会社や銀行などの発行元の名前",
        Must_be_dated           :"提出日から90日以内の日付であること",
        Notes                   :"注意事項",
        Ensure_documents        :"提出する書類は、応募フォームに記載された情報と一致していることを確認してください。",
        Submit_complete         :"身分証明書は、ブロックやトリミングをせず、完全なものを提出してください。",
        Take_clear              :"重要な情報がぼやけないように、鮮明でピントの合った画像を撮影してください。",
        When_capturing          :"書類の画像を撮影する際は、歪みを避けるために、カメラが書類と平行になるようにします。",
        Do_not_add              :"透かしや使用目的を示すテキストを加えないこと。",
        If_your_full            :"フルネームにミドルネームやセカンドラストネームがある場合、KYC提出の際にはファーストネームとラストネームの記入のみでOKです。",
        Please_email_verif      :"Eメール認証を完了してください",
        enter_PIN               :"パスワードを入力してください",
        enter_pwd_verif         :"パスワード認証を入力してください",
        pwd_not_match           :"2つのパスワードが一致しません",
        Please_Gender           :"性別を選択してください",
        mailing_address         :"郵送先住所を記入してください",
        mail_country            :"郵送国を選択してください",
        mail_city               :"郵送都市を記入してください",
        mail_state              :"郵送エリアにご記入ください",
        mail_postal_code        :"郵送コードを記入してください",
        upload_file_first       :"ファイルをアップロードしてください",
        Verify_name_first       :"ユーザー名を確認してください",
        verify_email_first      :"Eメールアドレスを確認してください",
        Email_verification      :"Eメール認証にパスしました",
        name_succeeded          :"ユーザー名の検証に合格しました",
        Cancelled               :"キャンセル",
        Driver_License          :"運転免許証 (Driver License)",
        Insurance_Policy        :"保険証書 (Insurance Policy)",
        Post_Balance            :"郵便局の残高証明書 (Post Office Balance Certificate)",
        Other_Government        :"その他政府発行の書類 (住民票)(Other Government Issued Document)",
        card_cost_status        :"カード手数料ステータス",
        card_cost_status0       :"未払い",
        card_cost_status1       :"有料",
        card_cost               :"カード手数料",
        Corporate_Clent_Prefix  :"会社名",
        The_company             :"会社名は必須です。会社名を設定してください",
        Click_jump              :"クリックして次へ",
        KYC_Management          :"KYCステータス",
        mailed                  :"Eメール",
        Card_anomaly            :"カード例外",
        Refuse_card             :"カードは交換されませんでした",
        replacement_card        :"交換する",
        Rep_card                :"交換保留中",
        Reissued_card           :"交換されました",
        Consolidating           :"統合中",
        Print_batch_number      :"ロット番号を印刷します。",
        company_abbreviation    :"会社名",
        delivery_type           :"配送タイプ",
        print_number            :"ロット番号を印刷します。",
        op_status_time          :"OPS ステータスの日付",
        op_cause_type1          :"紛失/盗難",
        op_cause_type2          :"損傷",
        op_cause_type3          :"ユーザーが被害を受けた",
        op_cause_type4          :"工場出荷時の破損",
        op_cause_type5          :"アクティブ化失敗",
        op_cause_type6          :"ピンの設定に失敗しました",
        op_cause_type7          :"配送の問題",
        op_cause_type8          :"詐欺",
        op_cause_type9          :"配達物が返送されていない",
        op_cause_type10         :"配達物が返送されていない",
        active_fail_reason      :"アクティベーション失敗の理由",
        mail_address            :"郵送先住所",
        View                    :"ビュー",
        Modify_status           :"動作ステータスの変更",
        Please_op_status        :"ステータスを選択してください",
        Card_abnormal_cause     :"カード異常原因",
        Select_card_cause       :"例外ケースを選択してください",
        Username                :"ユーザー名",
        Role                    :"役割",
        Apply_For               :"申請する",
        Staff                   :"スタッフ",
        kyc_id_status           :"Kyc ID ステータス",
        Under_Review            :"検討中",
        kyc_address_status      :"Kyc アドレスのステータス",
        KYC_Message             :"本人確認メッセージ",
        reject_reason1          :"データエラー",
        reject_reason2          :"ステータスエラー",
        reject_reason3          :"KYCは承認されていません",
        reject_reason4          :"割り当て失敗",
        reject_reason5          :"アクティベーションに失敗しました",
        reject_reason6          :"ピンの設定失敗",
        Operator                :"オペレータ",
        No_more_than_5          :"5文字以内",
        mailed_s                :"郵送された",
        For_banking_login       :"インターネットバンキングログイン用",
        not_filed               :"コミットされていない",
        annual_fee_status       :"年会費状況",
        card_replace_fee        :"カード交換手数料",
        card_price              :"カードあたりの基本コスト",
        sale_name               :"リレーションシップマネージャー",
        design_details          :"カード素材デザイン",
        design_category         :"デザイン部門",
        material                :"材料",
        material_color          :"素材の色",
        font_color              :"フォントの色",
        feb_logo                :"FEBロゴ",
        merchant_logo           :"クライアントロゴ",
        card_picture            :"カード画像",
        Packing_arrangement     :"包装タイプ",
        packaging_type          :"包装タイプ",
        done_by                 :"によって行われ",
        cost_to_client          :"クライアントのコスト",
        stage                   :"配達",
        from_to                 :"からの",
        printing_type           :"印刷タイプ",
        delivery_note           :"納品書",
        delivery_address        :"配送先住所",
        contract                :"接触",
        mobile_no               :"携帯番号",
        contract_id             :"契約ID",
        prepayment              :"元払い",
        returned                :"戻ってきた",
        There_problem_image     :"アップロードした画像形式に問題があります。別の画像形式でもう一度お試しください。",
        Collaborative_Cards     :"コラボカード",
        Pending_Rebind          :"再バインド保留中",
        Upload_error            :"ファイルのアップロードに失敗します。 ネットワーク更新ページを変更して再試行してください",
        card_username           :"カードユーザー名",
        top_up_fee              :"チャージ手数料",
        min_top_up              :"最低チャージ手数料",
        max_top_up              :"最高チャージ手数料",
        Full_Contract_Summary   :"完全な契約概要表",
        Contracted_Paid         :"契約数量 - 支払済み",
        Card_Qty_Order          :"注文可能なカード枚数",
        Total_Cards_Ordered     :"注文したカードの合計数",
        Total_Cards_Allocated   :"割り当てられたカードの合計数",
        Order_Summary_Page      :"注文概要ページ",
        Card_Qty_Allocation     :"割り当て保留中のカード数量",
        Card_Qty_Bind           :"バインド可能なカード枚数",
        Cards_ordered_available :"カードを注文して利用可能になりました",
        Total_Cards_Used        :"使用したカードの合計数",
        Card_Qty_print          :"カード枚数 印刷用に予約済み",
        Card_Qty_pending_Bind   :"印刷されたカードの枚数はバインド保留中です",
        Card_Qty_Activation     :"アクティベーションを待っているカードの枚数",
        Total_Cards_Activated   :"有効化されたカードの合計数",
        Total_Cards_Bind        :"バインドされたカードの合計数",
        Users                   :"ユーザー",
        users_kyc_approved      :"KYCが承認されたユーザーの総数",
        users_pending_kyc       :"KYC保留中の現在のユーザー",
        pending_consolidation   :"統合保留中の現在のユーザー",
        pending_payment         :"支払い保留中の現在のユーザー",
        pending_users           :"保留中のユーザー",
        users_reserved_print    :"現在のユーザーは印刷用に予約されています",
        printed_pending_bind    :"現在のユーザーの印刷保留中のバインド",
        awaiting_activation     :"アクティベーションを待っている現在のユーザー",
        with_card_activated     :"カードがアクティベートされたユーザーの合計",
        with_card_bind          :"Card Bind の総ユーザー数",
        card_array              :"カードアレイ",
        plus_price              :"カードあたりの基本コスト",
        data_problem            :"データエラー",
        state_problem           :"ステータスエラー",
        User_kyc_failed         :"KYC審査未通過ユーザー",
        Allocation_card_failure :"カードの割り当てに失敗しました",
        Activation_failure      :"カードをアクティベートできませんでした",
        Failed_set_pin          :"PINの設定に失敗しました",
        Webhook_notif           :"Webhook通知設定",
        After_the_setting       :"セットアップが正常に完了すると、ステータスの変更に関する関連通知が届きます。",
        Please_API_link         :"API リンクを入力してください。",
        KYC_status_change       :"KYCステータス変更通知",
        status_noti             :"チャージステータス通知",
        Card_status_noti        :"カード稼働状況通知",
        activation_success      :"カードアクティベーション通知",
        Cancelling              :"キャンセルする",
        Beth_API_Status         :"BETH/API ステータス",
        CONTROLS                :"コントロール",
        Cards_List              :"カードリスト",
        Card_mailing_address    :"カードの郵送先住所",
        Mail_Address_Line       :"郵送先住所 1 行目",
        Mail_Address_Line2      :"郵送先住所 2 行目",
        Mail_City               :"郵送都市",
        Mail_State              :"郵送先の州",
        Mail_Country            :"郵送先の国",
        Mail_Postal_Code        :"郵便番号",
        Security_Code           :"アクティベーションコード",
        Sales_Type              :"販売形態",
        General                 :"一般的な",
        QR_Code                 :"QRコード",
        verify_passed           :"検証に合格しました",
        v_kit_number_code       :"最初に KIT コードとアクティベーション コードの検証を完了してください。 ご不明な点がございましたら、カスタマーサービスまでお問い合わせください。",
        URL                     :"URL",
        operating_time          :"そうさじかん",
        r_w_get                 :"受信者は取得します",
        Conversion_fee          :"の両替手数料",
        Flat_Fee                :"定額料金",
        Amount_Deducted         :"控除額",







    },
    beth_text:{
        Residential_address         :"住宅アドレス",
        Mail_Address_Line           :"住所1",
        Mail_Address_Line2          :"住所2",
        Mail_City                   :"市",
        Mail_State                  :"州",
        Mail_Country                :"国",
        Mail_Postal_Code            :"郵便番号",
        Block_Card                  :"カードブロック",
        Replace_Card                :"カードの再発行",
        renew                       :"年会費の継続",
        Expired                     :"期限切れ",
        Confirmed_freezing          :"このカードの一時的な使用制限を設定しますか？ブロックした場合、カードを解除するまで使用できません。",
        Confirmed_thawing           :"このカードの解除を確認しますか？解除後、カードを再びご利用いただけます。",
        Reason_replacement          :"カード再発行の理由を選択してください",
        Card_loss                   :"カード紛失",
        Confirm_to_freeze           :"カードの凍結を確認し、カード再発行手数料{fee} USDC/Tを支払います。この操作は取り消すことができません。",
        address_accurate            :"新しいカードを受け取るために、送付先住所が正確であることを確認してください。",
        Card_damage                 :"カードが損傷しています",
        Not_sure_card               :"カードを紛失したか不明ですか？新しい取引を止めるために",
        Temporarily_block_it        :"一時的にカードをブロック",
        Temporarily_block_it_btm    :"してください。",
        card_recovered              :"カードを見つけた場合、いつでも自分で解除し、使用を再開できます。",
        Whether_damaged             :"カードが損傷しているか不明ですか？追加の操作を行う前に、カスタマーサービスにお問い合わせいただくことができます。",
        Mailing_address_accurate    :"カードが破損しているかどうかわからない場合は、まずカスタマー サービスに連絡して確認してください。",
        card_administrator          :"操作を続行できません。管理者によってカードがブロックされました。",
        password_cannot_changed     :"現在の状況ではパスワードのリセットはサポートされていません。",
        Freezing_success            :"凍結完了",
        applied_replacement_card    :"カード再発行の申請があり、カードの解除ができません。詳細なサポートが必要な場合は、カスタマーサービスにお問い合わせください。",
        card_frozen_administrator   :"システム管理者により、お客様のカードは一時的に利用停止となりました。詳細な情報やお問い合わせは、カスタマーサービスまでお気軽にご連絡ください。",
        Card_replacement_success    :"カード再発行の申請が成功しました。",
        msg_notice                  :"お知らせ",
        system_notice               :"システムお知らせ",
        Clear_unread                :"すべて既読にする",
        Clear_successfully          :"クリア成功",
        Automatic_annual_renewal    :"自動年会費更新",
        Ticked_FEB                  :"次回の会員年会費（{payment_amount} USDC/T、{payment_month}ヶ月分）は、{payment_date} に所属する親会社の口座から自動的に引き落とされます。",
        Ticked_Beth                 :"次回の会員年会費（{payment_amount} USDC/T、{payment_month}ヶ月分）は、{payment_date} にBETHウォレットの残高から自動的に引き落とされます。サービスの中断を避けるために、十分な残高を確保してください。",
        Please_make                 :"カードのキャンセルを避けるために、{payment_date}までに{payment_amount} USDC/T（{payment_month}ヶ月分）をお支払いください。",
        Current_Annual              :"現在の年会費：{current_amount} USDC/T",
        Card_No                     :"カード番号",
        Expiry_Date                 :"有効期限",
        Term_Start_Date             :"開始日付",
        Term_End_Date               :"終了日付",
        Auto_Renewal_Date           :"支払い期日",
        Payment_Months              :"総月数",
        Membership_Fee_Due          :"手数料額",
        Payment_Status              :"支払い状況",
        pay                         :"支払う",
        pay1                        :"支払済み (Paid)",
        pay_another                 :"保留中 (Pending)",
        overdue                     :"期限超過 (Overdue)",
        unpaid                      :"未払い (Unpaid)",
        Payment_Date                :"支払日",
        need_to_pay                 :"この取引には {payment_amount} USDC/T の支払いが必要です。続行しますか？",
        successfully_set            :"設定完了",
        payment_success             :"支払い成功",
        renewal_first               :"まず前回の更新を完了してください ",
        Free_annual_fee             :" 年会費免除",
        feb_account                 :"FEB アカウントは、この取引に対して {payment_amount} USD C/T を支払う必要があります。 続けてもよろしいですか?",
        Account_Balance             :"アカウント残高",
        Delete_Read                 :"既読削除",
        Card_Name                   :"カード名",
        Cardholder_Agreement        :"カード会員規約",
        read_agree                  :"受け入れる",
        Unticked_Please             :"カードがキャンセルされないように、年月日までに{payment_amount} USDC/T（{payment_month}ヶ月）をお支払いください。",
        Your_been                   :"カードは再利用しないように指示されており、{annual_fee_end_time}で期限切れになります。お問い合わせください。",
        text34: 'アカウント名',
    },
    
    pdf: {
        'text1': 'デビットカード',
        'text2': 'アカウント明細書',
        'text3': 'カードサマリー',
        'text4': '明細書の日付',
        'text5': '最大儲蓄制限',
        'text6': '前回残高',
        'text7': 'チャージ',
        'text8': '引き出し',
        'text9': '手数料',
        'text10': 'カード残高',
        'text11': '次回更新期間:',
        'text12': 'ページ数',
        'text13': 'アカウントまたはカードに関するお問い合わせは、{{login_url}} にログインして行ってください。',
        'text14': 'デビットカード',
        'text15': '取引日',
        'text16': '説明',
        'text17': '金額',
        'text18': '残高',
        'text19': '総額',
        'text20': '前回の残高には、取引の処理時に未処理の引き出しや預け入れ資金の保留が反映されていないかもしれません。取引が処理されたときに利用可能な資金が不足していた場合、手数料が課金されている可能性があります。',
        'text21': '重要なお知らせ',
        'text22': '詐欺から自分を守る',
        'text23': '個人のログイン情報（ユーザーIDとパスワード）やデビットカードのPIN番号を決して他人と共有しないでください。',
        'text24': 'PIN番号のリセット',
        'text25': 'デビットカードの暗証番号を忘れましたか？アカウントにログインして、デビットカードの暗証番号を即座にリセットできます',
        'text26': 'デビットカード情報シート',
        'text27': ' この情報は、簡単な消費者ガイドとして提供されています。詳細については、常に優先される該当するカード会員契約をお読みください。',
        'text28': '最大儲蓄制限',
        'text29': ' いつでもカードアカウントに資金を追加できますが、最大儲蓄制限を超えてはいけません。',
        'text30': '外貨での取引',
        'text31': '外貨で取引を行う場合、VISAなどの支払いカードネットワークは、それを米ドル金額に変換します。支払いカードネットワークは独自の通貨変換手続きを使用します。処理日の有効な為替レートは、明細に表示されている取引日のレートと異なる場合があります。通貨の為替レートを調整することがあり、追加の通貨変換手数料を請求することがあります。',
        'text32': '取引料金',
        'text33': 'チャージ手数料',
        'text34': 'POS/オンライン購入',
        'text35': 'ATM現金引き出し手数料',
        'text36': 'ATM残高照会手数料',
        'text37': '取引パラメータ',
        'text38': '最大儲蓄制限',
        'text39': 'カードタイプに応じて ',
        'text40': '最低の値の保存',
        'text41': '1回の最大チャージ上限',
        'text42': '1日の最大取引回数',
        'text43': '1か月の最大取引回数',
        'text44': '1回の最大取引金額',
        'text45': '1日の最大取引金額',
        'text46': '1か月の最大取引金額',
        'text47': '1日の最大引き出し回数',
        'text48': '1か月の最大引き出し回数',
        'text49': '1日の最大引き出し金額',
        'text50': '1か月の最大引き出し金額',
        'text51': 'サービス料金',
        'text52': 'カード費用 ',
        'text53': 'カード有効化手数料 ',
        'text54': 'カード交換手数料',
        'text55': '月額サービス料金',
        'text56': '年会費',
        'text57': '本アカウントの結算書に含まれる情報とカード利用者契約書に不一致がある場合、カード利用者契約書の内容が優先されます。',
        'text58': '',
        'text59': '',

        text77: "サービス 追加カード発行手数料",
    },
    v_life:{
        visionLife_id   :"VisionLifeアカウント",
        verify_v_id     :"フォーマットエラー、文字、数字、特殊文字、5～20ビットの組み合わせ",
        id_verify_passed:"VisionLife ID 認証に合格しました",
        please_v_id     :"VisionLife アカウントを入力してください",
        read_content    :"続行するには、下にスクロールして契約に同意してください",
        Privacy_Data    :"隠私およびデータ使用声明",
        We_your_privacy :"私たちはあなたのプライバシーを尊重し、個人情報を保護することをお約束いたします。この申請書で提供されたデータは、アカウント処理および身分確認にのみ使用されます。法的要件に従わない限り、第三者にデータを開示しません。",
        Card_Name       :"カード名",
    },
    str_status:{
        str_status_1:"未提出",
        str_status_2:"検討中",
        str_status_3:"成功",
        str_status_4:"失敗",
    },
    top_up_dlg:{
        Max_per     :"一回の取引最大金額:",
        Current_Cap :"現在のチャージ上限:",
        Source_fund :"資金の出所",
        E_Income    :"雇用収入",
        I_Income    :"投資収益",
        B_Income    :"事業収入",
        Savings     :"預金",
        Loans       :"ローン",
        Sales_I     :"投資の売却",
        Gifts       :"贈り物",
        Others      :"その他",
        I_confirm   :"以上のように、これらの資金は合法的な出所から派生していることを確認し、将来必要があれば出所の証拠を提供することを約束します。",
        Please_check:"先に上記をチェックして申請を提出してください",
        t_status1   :"成功",
        t_status2   :"キャンセル",
        t_status3   :"処理中",
        t_status4   :"再試行",
        t_status5   :"リターンマッチ",
        P_may       :"このチャージの処理には3から5営業日かかる場合があります。",
    },
    beth_text2:{
        Residential_address         :"住宅アドレス",
        Mail_Address_Line           :"住所1",
        Mail_Address_Line2          :"住所2",
        Mail_City                   :"市",
        Mail_State                  :"州",
        Mail_Country                :"国",
        Mail_Postal_Code            :"郵便番号",
        Block_Card                  :"カードブロック",
        Replace_Card                :"カードの再発行",
        renew                       :"年会費の継続",
        Expired                     :"期限切れ",
        Confirmed_freezing          :"このカードの一時的な使用制限を設定しますか？ブロックした場合、カードを解除するまで使用できません。",
        Confirmed_thawing           :"このカードの解除を確認しますか？解除後、カードを再びご利用いただけます。",
        Reason_replacement          :"カード再発行の理由を選択してください",
        Card_loss                   :"カード紛失",
        Confirm_to_freeze           :"カードの凍結を確認し、カード再発行手数料{fee} USDC/Tを支払います。この操作は取り消すことができません。",
        address_accurate            :"新しいカードを受け取るために、送付先住所が正確であることを確認してください。",
        Card_damage                 :"カードが損傷しています",
        Not_sure_card               :"カードを紛失したか不明ですか？新しい取引を止めるために",
        Temporarily_block_it        :"一時的にカードをブロック",
        Temporarily_block_it_btm    :"してください。",
        card_recovered              :"カードを見つけた場合、いつでも自分で解除し、使用を再開できます。",
        Whether_damaged             :"カードが損傷しているか不明ですか？追加の操作を行う前に、カスタマーサービスにお問い合わせいただくことができます。",
        Mailing_address_accurate    :"カードが破損しているかどうかわからない場合は、まずカスタマー サービスに連絡して確認してください。",
        card_administrator          :"操作を続行できません。管理者によってカードがブロックされました。",
        password_cannot_changed     :"現在の状況ではパスワードのリセットはサポートされていません。",
        Freezing_success            :"凍結完了",
        applied_replacement_card    :"カード再発行の申請があり、カードの解除ができません。詳細なサポートが必要な場合は、カスタマーサービスにお問い合わせください。",
        card_frozen_administrator   :"システム管理者により、お客様のカードは一時的に利用停止となりました。詳細な情報やお問い合わせは、カスタマーサービスまでお気軽にご連絡ください。",
        Card_replacement_success    :"カード再発行の申請が成功しました。",
        msg_notice                  :"お知らせ",
        system_notice               :"システムお知らせ",
        Clear_unread                :"すべて既読にする",
        Clear_successfully          :"クリア成功",
        Automatic_annual_renewal    :"自動年会費更新",
        Ticked_FEB                  :"次回の会員年会費（{payment_amount} USDC/T、{payment_month}ヶ月分）は、{payment_date} に所属する親会社の口座から自動的に引き落とされます。",
        Ticked_Beth                 :"次回の会員年会費（{payment_amount} USDC/T、{payment_month}ヶ月分）は、{payment_date} にBETHウォレットの残高から自動的に引き落とされます。サービスの中断を避けるために、十分な残高を確保してください。",
        Please_make                 :"カードのキャンセルを避けるために、{payment_date}までに{payment_amount} USDC/T（{payment_month}ヶ月分）をお支払いください。",
        Current_Annual              :"現在の年会費：{current_amount} USDC/T",
        Card_No                     :"カード番号",
        Expiry_Date                 :"有効期限",
        Term_Start_Date             :"開始日付",
        Term_End_Date               :"終了日付",
        Auto_Renewal_Date           :"支払い期日",
        Payment_Months              :"総月数",
        Membership_Fee_Due          :"手数料額",
        Payment_Status              :"支払い状況",
        pay                         :"支払う",
        pay1                        :"支払済み (Paid)",
        pay_another                 :"保留中 (Pending)",
        overdue                     :"期限超過 (Overdue)",
        unpaid                      :"未払い (Unpaid)",
        Payment_Date                :"支払日",
        need_to_pay                 :"この取引には {payment_amount} USDC/T の支払いが必要です。続行しますか？",
        successfully_set            :"設定完了",
        payment_success             :"支払い成功",
        renewal_first               :"まず前回の更新を完了してください ",
        Free_annual_fee             :" 年会費免除",
        feb_account                 :"FEB アカウントは、この取引に対して {payment_amount} USD C/T を支払う必要があります。 続けてもよろしいですか?",
        Account_Balance             :"アカウント残高",
        Delete_Read                 :"既読削除",
        Card_Name                   :"カード名",
        Cardholder_Agreement        :"カード会員規約",
        read_agree                  :"受け入れる",
        Renewal_Status              :"更新ステータス",
        free_charge                 :"無料",
        due_soon                    :"今後の予定",
        Deduction_Mode              :"控除モード",
        auto                        :"自動",
        automatically               :"支払いを確認しました",
        stop                        :"停止",
        Modify_Mode                 :"モード変更",
        Edit_Remarks                :"備考の編集",
        Pending_status              :"保留中",
        Discontinued                :"製造中止",
        User                        :"ユーザー",
        yearly_expire_date          :"年間有効期限",

    },
    new1_txt:{
        Unsettled           :"不定住",
        Settled             :"決済済み",
        CR                  :"入金",
        DR                  :"引出し",
    },
    new3_txt:{
        P_Resubmission      :"ユーザーが再送信するまで待機",
        KYC_Rejected        :"KYCは拒否された",
        ekyc_link           :"eKYCリンク",
        current_PIN         :"現在の4桁のPIN",
    }


}